import { Apartment } from "../types";

export const mockApartments: Apartment[] = [
  {
    id: "1",
    title: "Modern Loft in Downtown",
    price: 2400,
    neighborhood: "Downtown",
    rooms: 2,
    sqm: 850,
    images: [
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
      "https://images.unsplash.com/photo-1556020685-ae41abfc9365?w=800&q=80",
    ],
    amenities: ["parking", "ac"],
    petFriendly: false,
    view_count: 1245,
    like_count: 87,
    landlord: {
      name: "Sarah Johnson",
      phone: "(555) 123-4567",
    },
  },
  {
    id: "2",
    title: "Spacious 2BR with City Views",
    price: 3200,
    neighborhood: "Midtown",
    rooms: 3,
    sqm: 1200,
    images: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80",
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&q=80",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=800&q=80",
    ],
    amenities: ["parking", "ac", "gym"],
    petFriendly: true,
    view_count: 2103,
    like_count: 156,
    landlord: {
      name: "Michael Chen",
      phone: "(555) 234-5678",
    },
  },
  {
    id: "3",
    title: "Cozy Studio near Park",
    price: 1800,
    neighborhood: "West Side",
    rooms: 1,
    sqm: 600,
    images: [
      "https://images.unsplash.com/photo-1536376072261-38c75010e6c9?w=800&q=80",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800&q=80",
      "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=800&q=80",
    ],
    amenities: [],
    petFriendly: false,
    view_count: 982,
    like_count: 45,
    landlord: {
      name: "Emily Rodriguez",
      phone: "(555) 345-6789",
    },
  },
  {
    id: "4",
    title: "Luxury 3BR Penthouse",
    price: 5500,
    neighborhood: "Upper East",
    rooms: 4.5,
    sqm: 2000,
    images: [
      "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=800&q=80",
      "https://images.unsplash.com/photo-1574643156929-51fa098b0394?w=800&q=80",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80",
    ],
    amenities: ["parking", "ac", "gym", "pool"],
    petFriendly: true,
    view_count: 3421,
    like_count: 298,
    landlord: {
      name: "David Park",
      phone: "(555) 456-7890",
    },
  },
  {
    id: "5",
    title: "Charming 1BR in Historic District",
    price: 2100,
    neighborhood: "Old Town",
    rooms: 2,
    sqm: 750,
    images: [
      "https://images.unsplash.com/photo-1554995207-c18c203602cb?w=800&q=80",
      "https://images.unsplash.com/photo-1571508601936-6d2e8c4f8c5f?w=800&q=80",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    ],
    amenities: ["ac"],
    petFriendly: false,
    view_count: 1567,
    like_count: 112,
    landlord: {
      name: "Jessica Lee",
      phone: "(555) 567-8901",
    },
  },
  {
    id: "6",
    title: "Pet-Friendly 2BR Garden Apartment",
    price: 2800,
    neighborhood: "Green District",
    rooms: 3.5,
    sqm: 1100,
    images: [
      "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?w=800&q=80",
      "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=800&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    ],
    amenities: ["parking", "ac"],
    petFriendly: true,
    view_count: 1890,
    like_count: 134,
    landlord: {
      name: "Robert Taylor",
      phone: "(555) 678-9012",
    },
  },
  {
    id: "7",
    title: "Modern Studio with Gym Access",
    price: 1950,
    neighborhood: "Fitness District",
    rooms: 1,
    sqm: 550,
    images: [
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80",
      "https://images.unsplash.com/photo-1585264550248-1778be3b6368?w=800&q=80",
      "https://images.unsplash.com/photo-1581404529954-084b8f43e3af?w=800&q=80",
    ],
    amenities: ["gym", "ac"],
    petFriendly: false,
    view_count: 876,
    like_count: 65,
    landlord: {
      name: "Amanda White",
      phone: "(555) 789-0123",
    },
  },
  {
    id: "8",
    title: "Family-Sized 3BR with Parking",
    price: 3800,
    neighborhood: "Suburban Heights",
    rooms: 4,
    sqm: 1600,
    images: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80",
      "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80",
    ],
    amenities: ["parking", "ac"],
    petFriendly: true,
    view_count: 1120,
    like_count: 98,
    landlord: {
      name: "Thomas Martinez",
      phone: "(555) 890-1234",
    },
  },
];
